import { Injectable } from '@angular/core';
import { TrinityService } from '../trinity/trinity.service';
import {
  PostFileSequenceInstanceResponse,
  GetFileSequenceTemplatesResponse,
  GetFileSequenceInstancesResponse,
} from 'app/types';

@Injectable({
  providedIn: 'root',
})
export class FileSequenceService {
  constructor(private trinityService: TrinityService) {}

  getFileSequenceTemplates() {
    return this.trinityService.get<GetFileSequenceTemplatesResponse>(
      `/file-sequence-template`,
      { authorized: true },
    );
  }

  startFileSequence(fileId: string, templateId: number) {
    return this.trinityService.post<PostFileSequenceInstanceResponse>(
      `/file-sequence-instance/${templateId}/${fileId}`,
      { authorized: true },
    );
  }

  getFileSequenceInstance(fileId: string) {
    return this.trinityService.get<GetFileSequenceInstancesResponse>(
      `/file-sequence-instance/${fileId}`,
      { authorized: true },
    );
  }
}
